var AppDispatcher = require('../core/AppDispatcher.jsx');
var Constants = require('../constants/SuperFirstTransferConstant.js');

var ActionTypes = Constants.ActionTypes;

module.exports = {
    updateSuperFirstTransferData: function (fieldName, value) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.UPDATE_SUPER_FIRST_DATA,
            fieldName: fieldName,
            value: value
        });
    },

    updateIsAdviceFeeOneOffExist: function(value) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.UPDATE_IS_ADVICE_FEE_ONEOFF_EXIST,
            isExist: value
        });

    }
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./actions/SuperFirstTransferAction.js